import { isEqual } from 'lodash-es';
import { Frequency, ScheduleConfigurationInput } from '@iss/libs/graphql';

// TODO: Add UT
export const isSemanticallyEqual = (a: ScheduleConfigurationInput, b: ScheduleConfigurationInput): boolean => {
  if (
    !isEqual(a.frequency, b.frequency) ||
    !isEqual(a.startDate, b.startDate) ||
    !isEqual(a.endDate, b.endDate)
  ) {
    return false;
  }

  switch (a.frequency) {
    case Frequency.Daily:
      return a.dailyEveryWeekday
        ? isEqual(a.dailyEveryWeekday, b.dailyEveryWeekday)
        : isEqual(a.recurrenceCounter, b.recurrenceCounter);
    case Frequency.Weekly:
      return isEqual(a.recurrenceCounter, b.recurrenceCounter) && isEqual(a.weeklyRecurrenceDayNames, b.weeklyRecurrenceDayNames);
    case Frequency.Monthly:
      if (a.monthlyRecurrenceConfig && b.monthlyRecurrenceConfig) {
        return isEqual(a.monthlyRecurrenceConfig.monthlyRecurrenceConfigType, b.monthlyRecurrenceConfig.monthlyRecurrenceConfigType) &&
          isEqual(a.monthlyRecurrenceConfig.monthlyRecurrenceConfigDay, b.monthlyRecurrenceConfig.monthlyRecurrenceConfigDay) &&
          isEqual(a.recurrenceCounter, b.recurrenceCounter);
      }

      return (isEqual(a.recurrenceCounter, b.recurrenceCounter) && isEqual(a.monthlyRecurrenceDayNumber, b.monthlyRecurrenceDayNumber));
    default:
      return false;
  }
};
